@for (option of options(); track option.capability) {
  <div class="flex items-center justify-between gap-3 py-2" [attr.data-testid]="option.rowTestId">
    <app-ai-capability-label [capability]="option.capability" [withTooltip]="false" />
    <span class="flex items-center gap-3">
      <span class="text-secondary text-sm" [attr.data-testid]="option.countTestId"
        >({{ option.count }})</span
      >
      <p-checkbox
        [binary]="true"
        [ngModel]="option.selected"
        (onChange)="toggle(option.capability, $event.checked)"
        [inputId]="option.inputId"
        [attr.data-testid]="option.checkboxTestId"
      ></p-checkbox>
    </span>
  </div>
}
